/**
 * Injects a value prop metaobject into the OrderGroove subscription widget
 */
(function () {
  const waitForOrderGroove = () => {
    const checkInterval = setInterval(() => {
      const ogOffer = document.querySelector("og-offer");
      const subscribeOption = document.querySelector("og-optin-button");

      if (ogOffer && subscribeOption) {
        clearInterval(checkInterval);
        setupValueProps();
      }
    }, 100);

    // Stop checking after 10 seconds
    setTimeout(() => clearInterval(checkInterval), 10000);
  };

  const setupValueProps = () => {
    // This is set up in main-product--default.liquid
    const valuePropsData = window.tulaSubscriptionValueProps;

    if (
      !valuePropsData ||
      !valuePropsData.items ||
      valuePropsData.items.length === 0
    )
      return;

    const valuePropsContainer = document.createElement("div");
    valuePropsContainer.className = "og-value-props";

    const visibility = valuePropsData.visibility || "on_subscribe";
    if (visibility === "on_subscribe") {
      valuePropsContainer.classList.add("og-value-props--conditional");
    }

    const listItems = valuePropsData.items
      .map(
        (text) => `
        <li class="og-value-props__item">
          ${valuePropsData.icon ?? ""}
          <span class="og-value-props__text">${text}</span>
        </li>`
      )
      .join("");

    valuePropsContainer.innerHTML = `
      <ul class="og-value-props__list">
        ${listItems}
      </ul>
    `;

    // After the subscribe option, before the frequency dropdown
    const incentiveDropdown = document.querySelector(".og-incentive-dropdown");

    if (incentiveDropdown) {
      incentiveDropdown.parentNode.insertBefore(
        valuePropsContainer,
        incentiveDropdown
      );
    }

    const updateValuePropsVisibility = () => {
      const ogOffer = document.querySelector("og-offer");
      if (!ogOffer) return;
      // The og-offer element gets a [subscribed] attribute when subscribe is selected
      const isSubscribed = ogOffer.hasAttribute("subscribed");
      if (isSubscribed) {
        valuePropsContainer.classList.add("og-value-props--visible");
      } else {
        valuePropsContainer.classList.remove("og-value-props--visible");
      }
    };

    // If conditional visibility, observe the subscribed attribute on og-offer
    if (visibility === "on_subscribe") {
      const ogOffer = document.querySelector("og-offer");

      if (!ogOffer) return;
      // Set initial visibility based on current state
      updateValuePropsVisibility();

      // Use MutationObserver to watch for the subscribed attribute change
      const observer = new MutationObserver(updateValuePropsVisibility);
      observer.observe(ogOffer, {
        attributes: true,
        attributeFilter: ["subscribed"],
      });
    }
  };

  // Initialize when DOM is ready, but only on product pages
  const init = () => {
    if (!document.body.classList.contains("template-product")) return;
    waitForOrderGroove();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
